import { IEntityMinimalModel, ISignableEntityParameters } from "../../../../api/GenericTypes";
import { SignatureType } from "../../../../api/Signature";
import { toValidDate } from "../../../datetime/DateTimeFormatter";

export interface ISignableEntityForm {
  signedByIds?: IEntityMinimalModel[] | undefined | null;
  notSignedByIds?: IEntityMinimalModel[] | undefined | null;
  signedFrom?: Date | undefined | null;
  signedTo?: Date | undefined | null;
  signatureTypes?: { id: SignatureType; name: SignatureType }[] | undefined | null;
  isSigned?: boolean | undefined | null;
}

export const SignableEntityDefaultFilterFormValues: Required<ISignableEntityForm> = {
  signedByIds: null,
  notSignedByIds: null,
  signedFrom: null,
  signedTo: null,
  signatureTypes: null,
  isSigned: null,
};

export const signableEntityFormToFilters = <Filters extends Partial<ISignableEntityParameters>>(
  form: ISignableEntityForm
): Filters => {
  let filters = {} as Filters;
  filters.signedByIds =
    Array.isArray(form.signedByIds) && form.signedByIds.length > 0 ? form.signedByIds?.map((d) => d.id) : null;
  filters.notSignedByIds =
    Array.isArray(form.notSignedByIds) && form.notSignedByIds.length > 0 ? form.notSignedByIds?.map((d) => d.id) : null;
  filters.signedFrom = toValidDate(form.signedFrom);
  filters.signedTo = toValidDate(form.signedTo);
  filters.signatureTypes =
    Array.isArray(form.signatureTypes) && form.signatureTypes.length > 0 ? form.signatureTypes.map((d) => d.id) : null;
  filters.isSigned = form.isSigned ?? null;
  return filters;
};

export const signableEntityFiltersToForm = (filters: Partial<ISignableEntityParameters>): ISignableEntityForm => {
  return {
    signedByIds: filters.signedByIds ? filters.signedByIds.map((id) => ({ id, name: "" })) : null,
    notSignedByIds: filters.notSignedByIds ? filters.notSignedByIds.map((id) => ({ id, name: "" })) : null,
    signedFrom: filters.signedFrom ? new Date(filters.signedFrom) : null,
    signedTo: filters.signedTo ? new Date(filters.signedTo) : null,
    signatureTypes: filters.signatureTypes
      ? filters.signatureTypes.map((id) => ({ id, name: id as SignatureType }))
      : null,
    isSigned: filters.isSigned ?? null,
  };
};
